module.exports = __webpack_public_path__ + "img/watch-circle.144fb269.svg";